import React, { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { useAuth } from "../../hooks/useAuth";
import { useUserStore } from "../../store/userStore";

function PushHandler() {
  const { refreshUser } = useAuth();

  const { accessToken } = useUserStore(
    useShallow((state) => ({
      accessToken: state.accessToken,
    }))
  );

  useEffect(() => {
    if (accessToken) {
      refreshUser();

      const intervalId = setInterval(() => {
        refreshUser();
      }, 60000);

      return () => clearInterval(intervalId);
    }
  }, [accessToken]);

  return <></>;
}

export default PushHandler;
